<template>
  <div class="custom-accordion text-center" ref="petResults">
    <div v-for="breed in breeds" :key="breed.id" @click="handleClick(breed)" class="custom-accordion-item text-truncate">
      {{ breed.name }}
    </div>
    <template v-if="breeds.length === 0">
        <span class="text-danger"> No results found </span>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
  export default {
    name: 'PetBreedSearchFieldResults',
    props: {
      breeds: []
    },
    methods: {
      handleClick (breed) {
        this.$emit('breedSelected', breed)
      }
    },
    mounted() {
      this.$nextTick(() => {
        this.$refs.petResults.scrollIntoView({ behavior: 'smooth' });
      });
    }
  }
</script>
